import React, { useContext, useEffect, useState } from 'react'
import { ContainerNew } from 'presentation/shared/components/ContainerNew'
import { useHistory, useLocation } from 'react-router'
import HeaderNew from 'presentation/shared/components/HeaderNew'
import TextFieldNew from 'presentation/shared/components/TextFieldNew'
import { AmbulatoryAuthorizationDashboardContext } from 'main/factories/pages/doctor/ambulatory-authorization/ambulatory-authorization-dashboard-factory'
import ButtonNew from 'presentation/shared/components/ButtonNew'
import { useFormik } from 'formik'
import { useServices } from 'presentation/hooks/use-services'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import SelectFieldNew from 'presentation/shared/components/SelectFieldNew'
import { toast } from 'react-toastify'
import { GetHealthInsuranceByPatient } from 'domain/usecases/patient/get-health-insurance-by-patient'
import { GetAllHealthPlans } from 'domain/usecases/patient/get-all-health-plans'

import moment from 'moment'
import { dateMask } from 'presentation/utils/masks'
import * as S from './styles'
import { validationSchema } from './validationSchema'

type LocationProps = {
  isEditing?: boolean
}

export const AmbulatoryInsuranceStepLayout = WithLoading(
  ({ setIsLoading }: WithLoadingProps) => {
    const history = useHistory()
    const stateLocation = useLocation()?.state as LocationProps
    const patientService = useServices().patient
    const { state, dispatch } = useContext<any>(
      AmbulatoryAuthorizationDashboardContext
    )

    const [healthInsurances, setHealthInsurances] =
      useState<GetAllHealthPlans.Model>([] as GetAllHealthPlans.Model)

    const [patientHealthInsuranceValues, setPatientHealthInsuranceValues] =
      useState<GetHealthInsuranceByPatient.HealthInsuranceInfo>(
        {} as GetHealthInsuranceByPatient.HealthInsuranceInfo
      )
    const [insuranceOptions, setInsuranceOptions] = useState<any>([])
    const [healthPlanOptions, setHealthPlanOptions] = useState<any>([])
    const [healthSubPlanOptions, setHealthSubPlanOptions] = useState<any>([])

    const formik = useFormik({
      initialValues: {
        health_insurance_name:
          patientHealthInsuranceValues?.health_insurance_name || '',
        health_insurance_code:
          patientHealthInsuranceValues?.health_insurance_code || '',
        health_plan_name: patientHealthInsuranceValues?.health_plan_name || '',
        health_plan_code: patientHealthInsuranceValues?.health_plan_code || '',
        health_sub_plan_name:
          patientHealthInsuranceValues?.health_sub_plan_name || '',
        health_sub_plan_code:
          patientHealthInsuranceValues?.health_sub_plan_code || '',
        health_card: patientHealthInsuranceValues?.health_card || '',
        company_name: patientHealthInsuranceValues?.company_name || '',
        valid_thru:
          patientHealthInsuranceValues?.valid_thru &&
          moment.utc(patientHealthInsuranceValues?.valid_thru).isValid()
            ? moment
                .utc(patientHealthInsuranceValues?.valid_thru)
                .format('DD/MM/YYYY')
            : ''
      },
      validationSchema: validationSchema,
      enableReinitialize: true,
      validateOnBlur: true,
      validateOnChange: true,
      onSubmit: async (values) => {
        try {
          setIsLoading(true)

          if (hasHealthInfoChanged(patientHealthInsuranceValues, values)) {
            const { patient } = state

            await patientService.createHealthInsuranceByPatient({
              patient_id: patient.patient_id,
              patient_name: patient.name,
              health_insurance_code: +values.health_insurance_code,
              health_insurance_name: values.health_insurance_name,
              company_name: values.company_name,
              health_plan_code: +values.health_plan_code,
              health_plan_name: values.health_plan_name,
              health_sub_plan_code: values.health_sub_plan_code
                ? +values.health_sub_plan_code
                : null,
              health_sub_plan_name: values.health_sub_plan_name,
              valid_thru: moment(values.valid_thru, 'DD/MM/YYYY').isValid()
                ? moment(values.valid_thru, 'DD/MM/YYYY').format('YYYY-MM-DD')
                : '',
              health_card: values.health_card
            })
            stateLocation?.isEditing
              ? history.push('resumo')
              : history.push('unidade')
          } else {
            stateLocation?.isEditing
              ? history.push('resumo')
              : history.push('unidade')
          }
        } catch (error: any) {
          toast.error(error?.message)
        } finally {
          const health_insurance_info = {
            health_insurance_code: +values.health_insurance_code,
            health_insurance_name: values.health_insurance_name,
            health_plan_code: +values.health_plan_code,
            health_plan_name: values.health_plan_name,
            company_name: values.company_name,
            health_sub_plan_code: +values.health_sub_plan_code,
            health_sub_plan_name: values.health_sub_plan_name,
            valid_thru: moment(values.valid_thru, 'DD/MM/YYYY').isValid()
              ? moment(values.valid_thru, 'DD/MM/YYYY').format('YYYY-MM-DD')
              : '',
            health_card: values.health_card
          }

          dispatch({
            type: 'HEALTH_INSURANCE_INFO',
            payload: health_insurance_info
          })

          setIsLoading(false)
        }
      }
    })

    function hasHealthInfoChanged(
      patientInfo: GetHealthInsuranceByPatient.HealthInsuranceInfo,
      healthInfo: any
    ): boolean {
      return (
        patientInfo.health_card !== healthInfo.health_card
        // patientInfo.patient_id !== healthInfo.patient_id ||
        // patientInfo.health_insurance_code !==
        //   healthInfo.health_insurance_code ||
        // patientInfo.health_insurance_name !==
        //   healthInfo.health_insurance_name ||
        // patientInfo.company_name !== healthInfo.company_name ||
        // patientInfo.health_plan_code !== healthInfo.health_plan_code ||
        // patientInfo.health_plan_name !== healthInfo.health_plan_name ||
        // patientInfo.health_sub_plan_code !== healthInfo.health_sub_plan_code ||
        // patientInfo.health_sub_plan_name !== healthInfo.health_sub_plan_name ||
        // moment(patientInfo.valid_thru).format('DD/MM/YYYY') !==
        //   healthInfo.valid_thru
      )
    }

    async function loadHealthPlans() {
      try {
        const response = await patientService.getAllHealthPlans()

        if (response.length > 0) {
          setHealthInsurances(response)

          const mappedHealthInsuranceOptions = response?.map(
            (healthInsurance) => {
              return {
                value: healthInsurance.health_insurance_id,
                label: healthInsurance.name
              }
            }
          )

          setInsuranceOptions(mappedHealthInsuranceOptions)
        }
      } catch (error: any) {
        toast.error(error?.message)
      }
    }

    async function loadPatientHealthInsuranceInfo() {
      try {
        const response = await patientService.getHealthInsuranceByPatient({
          is_active: true,
          last_health_insurance: true,
          patient_id: state.patient.patient_id
        })

        if (response?.length > 0) {
          setPatientHealthInsuranceValues(response[0])
          formik.setValues(response[0])
          formik.setFieldValue(
            'valid_thru',
            response[0].valid_thru &&
              moment.utc(response[0].valid_thru).isValid()
              ? moment.utc(response[0].valid_thru).format('DD/MM/YYYY')
              : ''
          )
        }

        return response?.[0]
      } catch (error: any) {
        toast.error(error?.message)
      }
    }

    async function loadHealthSubPlans(
      healthInsuranceId: number,
      healthPlanId: number
    ) {
      try {
        const response = await patientService.getHealthSubPlans({
          health_insurance_id: healthInsuranceId,
          plan_id: healthPlanId
        })

        if (response.length > 0) {
          const mappedHealthSubPlansOptions = response.map((subPlan: any) => {
            return {
              label: subPlan.name,
              value: subPlan.sub_plan_id
            }
          })
          setHealthSubPlanOptions(mappedHealthSubPlansOptions)
        }
      } catch (error: any) {
        toast.error(error?.message)
      }
    }

    const getData = async () => {
      if (!state?.patient?.cpf) {
        return history.push('/pedidos-autorizacao-ambulatorial/solicitacao')
      }
      setIsLoading(true)
      try {
        await loadHealthPlans()
        await loadPatientHealthInsuranceInfo()
      } catch (error: any) {
        console.error(error?.message)
      } finally {
        setIsLoading(false)
      }
    }

    const getSubPlanData = async () => {
      setIsLoading(true)
      try {
        if (
          !!formik.values.health_insurance_code &&
          !!formik.values.health_plan_code
        ) {
          await loadHealthSubPlans(
            Number(formik.values.health_insurance_code),
            Number(formik.values.health_plan_code)
          )
        }
      } catch (error: any) {
        console.error(error?.message)
      } finally {
        setIsLoading(false)
      }
    }

    useEffect(() => {
      getData()
    }, [])

    useEffect(() => {
      if (
        !!formik.values.health_insurance_code &&
        !!formik.values.health_plan_code
      ) {
        getSubPlanData()
      }
    }, [formik.values.health_insurance_code, formik.values.health_plan_code])

    useEffect(() => {
      if (
        healthInsurances.length > 0 &&
        !!formik?.values.health_insurance_code
      ) {
        setIsLoading(true)

        const filteredHealthPlanOptions = healthInsurances
          ?.filter(
            (healthInsurance) =>
              healthInsurance.health_insurance_id ===
              formik?.values.health_insurance_code
          )
          ?.map((healthInsurance) => healthInsurance.plans)

        const mappedHealthPlanOptions = filteredHealthPlanOptions[0]?.map(
          (item) => {
            return {
              label: item.name,
              value: item.plan_id
            }
          }
        )

        setHealthPlanOptions(mappedHealthPlanOptions)
        if (mappedHealthPlanOptions?.length > 0) {
          setIsLoading(false)
        }
      }
    }, [formik.values.health_insurance_code, insuranceOptions])

    function handleChangeHealthInsurance(event: any) {
      const selectedOption = insuranceOptions.find(
        (option: any) => String(option.value) === event.target.value
      )

      if (selectedOption) {
        formik.setFieldValue('health_insurance_code', selectedOption.value)
        formik.setFieldValue('health_insurance_name', selectedOption.label) // Captura o label também
      }

      formik.setFieldValue('health_plan_code', '')
      formik.setFieldValue('health_sub_plan_code', '')
      formik.setFieldValue('health_card', '')
      formik.setFieldValue('valid_thru', '')
      setHealthSubPlanOptions([])
    }

    function handleChangePlanCode(event: any) {
      const selectedOption = healthPlanOptions.find(
        (option: any) => String(option.value) === event.target.value
      )

      if (selectedOption) {
        formik.setFieldValue('health_plan_code', selectedOption.value)
        formik.setFieldValue('health_plan_name', selectedOption.label) // Captura o label também
      }

      formik.handleChange(event)
      formik.setFieldValue('health_sub_plan_code', '')
      formik.setFieldValue('health_card', '')
      formik.setFieldValue('valid_thru', '')
      setHealthSubPlanOptions([])
    }

    function handleChangeSubPlanCode(event: any) {
      const selectedOption = healthSubPlanOptions.find(
        (option: any) => String(option.value) === event.target.value
      )

      if (selectedOption) {
        formik.setFieldValue('health_sub_plan_code', selectedOption.value)
        formik.setFieldValue('health_sub_plan_name', selectedOption.label) // Captura o label também
      }

      formik.handleChange(event)
      formik.setFieldValue('health_card', '')
      formik.setFieldValue('valid_thru', '')
    }

    return (
      <>
        <HeaderNew
          actualPageOnClick={() =>
            stateLocation?.isEditing ? history.push('resumo') : history.goBack()
          }
          actualPageTitle="Solicitar pedido ambulatorial"
        />

        <ContainerNew
          title="Convênio"
          titleColor="neutral800"
          titleSize="large"
          titleWeight="bold"
          // style={{ paddingBottom: 0 }}
          primaryButton={
            <ButtonNew
              fullWidth
              size="large"
              onClick={formik.submitForm}
              disabled={formik.isSubmitting || !formik.isValid}
            >
              {stateLocation?.isEditing ? 'Salvar' : 'Próximo'}
            </ButtonNew>
          }
        >
          <S.Wrapper>
            <S.FormWrapper onSubmit={formik.handleSubmit}>
              <SelectFieldNew
                labelOverlapping
                label="Convênio *"
                labelSize="xxsmall"
                labelWeight="semiBold"
                labelColor="neutral700"
                placeholder="Selecione"
                name="health_insurance_code"
                id="health_insurance_code"
                items={insuranceOptions}
                onChange={handleChangeHealthInsurance}
                onBlur={formik.handleBlur}
                error={
                  formik.touched.health_insurance_name
                    ? formik.errors.health_insurance_name
                    : undefined
                }
                value={String(formik?.values?.health_insurance_code) || ''}
              />
              <SelectFieldNew
                label="Plano"
                labelOverlapping
                labelSize="xxsmall"
                labelWeight="semiBold"
                labelColor="neutral700"
                placeholder="Selecione"
                name="health_plan_code"
                id="health_plan_code"
                value={formik.values.health_plan_code}
                onChange={handleChangePlanCode}
                items={healthPlanOptions}
              />

              <SelectFieldNew
                label="Subplano"
                labelOverlapping
                labelSize="xxsmall"
                labelWeight="semiBold"
                labelColor="neutral700"
                placeholder="Selecione"
                name="health_sub_plan_code"
                id="health_sub_plan_code"
                value={formik.values.health_sub_plan_code}
                onChange={handleChangeSubPlanCode}
                items={healthSubPlanOptions}
              />

              <TextFieldNew
                type="text"
                label="Número da carteira "
                labelOverlapping
                labelSize="xxsmall"
                labelWeight="normal"
                labelColor="neutral700"
                placeholder="Digite"
                name="health_card"
                value={formik.values.health_card}
                onChange={formik.handleChange('health_card')}
                onBlur={formik.handleBlur}
                required
                requiredColor="neutral800"
                error={formik.touched.health_card && formik.errors.health_card}
                maxLength={25}
              />
              <TextFieldNew
                label="Empresa (titular do plano)"
                labelOverlapping
                labelSize="xxsmall"
                labelWeight="normal"
                labelColor="neutral700"
                placeholder="Digite"
                name="company_name"
                value={formik.values.company_name}
                onChange={formik.handleChange('company_name')}
                onBlur={formik.handleBlur}
              />
              <TextFieldNew
                label="Validade da carteira"
                placeholder="dd/mm/aaaa"
                labelOverlapping
                labelSize="xxsmall"
                labelWeight="normal"
                labelColor="neutral700"
                name="valid_thru"
                mask={dateMask}
                onChange={formik.handleChange('valid_thru')}
                onBlur={formik.handleBlur}
                value={formik.values.valid_thru}
                error={formik.touched.valid_thru && formik.errors.valid_thru}
              />
            </S.FormWrapper>
          </S.Wrapper>
        </ContainerNew>
      </>
    )
  }
)

export default AmbulatoryInsuranceStepLayout
